import React from 'react';

const TravelInspiration: React.FC = () => {
  const inspirationCategories = [
    {
      title: "Hidden Beaches",
      description: "Discover secluded paradise beaches away from the crowds",
      image: "hidden-beaches"
    },
    {
      title: "Ancient Temples",
      description: "Explore magnificent temples and historical architecture",
      image: "ancient-temples"
    },
    {
      title: "Local Cuisine",
      description: "Taste authentic flavors and culinary traditions",
      image: "local-cuisine"
    },
    {
      title: "City Lights",
      description: "Experience vibrant nightlife and urban adventures",
      image: "city-lights"
    }
  ];

  return (
    <section className="travel-inspiration">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Travel Inspiration</h2>
          <p className="section-subtitle">
            Get inspired by unique travel experiences and discover your next adventure
          </p>
        </div>
        <div className="inspiration-grid">
          {inspirationCategories.map((category, index) => (
            <div key={index} className="inspiration-card">
              <div className={`inspiration-image ${category.image}`}></div>
              <div className="inspiration-content">
                <h3 className="inspiration-title">{category.title}</h3>
                <p className="inspiration-description">{category.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TravelInspiration; 